module.exports = __webpack_public_path__ + "static/media/invite.d316268c.svg";